import styled from 'styled-components'
import type { MetricCardVariant } from './MetricCard.types'

export const Container = styled.div<{
  $variant: MetricCardVariant
  $disabled?: boolean
  $clickable?: boolean
}>`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  transition: all 0.2s ease;
  position: relative;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'success':
        return `border-left: 4px solid ${theme.colors.success};`
      case 'warning':
        return `border-left: 4px solid ${theme.colors.warning};`
      case 'danger':
        return `border-left: 4px solid ${theme.colors.danger};`
      case 'primary':
        return `border-left: 4px solid ${theme.colors.primary};`
      default:
        return ''
    }
  }}

  ${({ $clickable, theme }) =>
    $clickable &&
    `
    &:hover {
      border-color: ${theme.colors.primary};
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  `}

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const Title = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  line-height: 1.3;
  flex: 1;
`

export const TooltipContainer = styled.div`
  margin-left: 8px;
  flex-shrink: 0;
`

export const ValueContainer = styled.div`
  margin-bottom: 8px;
`

export const Value = styled.div<{ $variant: MetricCardVariant }>`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme, $variant }) => {
    switch ($variant) {
      case 'success':
        return theme.colors.success
      case 'warning':
        return theme.colors.warning
      case 'danger':
        return theme.colors.danger
      case 'primary':
        return theme.colors.primary
      default:
        return theme.colors.text.primary
    }
  }};
  line-height: 1.2;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const Subtitle = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  line-height: 1.3;
`

export const TrendContainer = styled.div<{
  $direction: 'up' | 'down' | 'neutral'
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme, $direction }) => {
    switch ($direction) {
      case 'up':
        return theme.colors.success
      case 'down':
        return theme.colors.danger
      default:
        return theme.colors.text.secondary
    }
  }};
`

export const TrendIcon = styled.span<{ $direction: 'up' | 'down' | 'neutral' }>`
  font-size: 10px;

  &::before {
    content: ${({ $direction }) => {
      switch ($direction) {
        case 'up':
          return '"▲"'
        case 'down':
          return '"▼"'
        default:
          return '"▶"'
      }
    }};
  }
`

export const IconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  opacity: 0.6;
  font-size: 20px;
`
